import { Box, Checkbox } from "emoreg";

import { SelectableAgency } from "../agency-filter-modal.types";

interface AgencyCheckboxProps {
  agency: SelectableAgency;
  onToggle: (agency: SelectableAgency) => void;
  isDisabled?: boolean;
}

export const AgencyCheckbox = ({ agency, onToggle, isDisabled }: AgencyCheckboxProps) => {
  return (
    <Box paddingTop={{ mobile: 8, tablet: 0 }} paddingBottom={{ mobile: 8, tablet: 0 }}>
      <Checkbox
        id={agency.uuid}
        disabled={isDisabled}
        checked={agency.isSelected}
        label={agency.name}
        onChange={() => onToggle(agency)}
      />
    </Box>
  );
};
